/**
 * created by tian ruo jun
 文本域
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Checkbox, Input, Select} from "antd";
import BaseComponent from "../../../../base/BaseComponent";

const {TextArea} = Input;

export default class RmtTextArea extends BaseComponent {
    static defaultProps = {
        type: "text",
        onChange: () => {
        },
        value: "",
    };
    static propTypes = {
        type: PropTypes.string.isRequired,
        onChange: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let {value, disabled, field, onChange, onChangeOfState, formItemSizeConfig, id} = this.props;
        let summaryMaxLength = this.sysConfigGetValueByKey("summary.max.length", "901")*1;
        return (
            <div style={{display:'flex'}}>
                <TextArea
                    id={id}
                    className={'rmt-textarea'}
                    size={formItemSizeConfig.inputSize}
                    rows={4}
                    maxLength={summaryMaxLength}
                    placeholder={`请输入`}
                    disabled={disabled}
                    value={value}
                    onChange={(e) => {
                        let val = e.target.value || '';
                        onChange(field, val)
                    }}
                />
                {/*<div style={{alignSelf: "flex-end", marginLeft: '8px', whiteSpace: "nowrap"}}>*/}
                {/*    <Checkbox*/}
                {/*        onChange={e => {*/}
                {/*            console.log('e.target.checked        ',e.target.checked);*/}
                {/*            let val="";*/}
                {/*            if(e.target.checked) {*/}
                {/*                val=this.props.contentText && this.props.contentText.length ? this.props.contentText.substring(0, summaryMaxLength) : "";*/}
                {/*            }*/}
                {/*            onChangeOfState('summaryDefaultChecked',e.target.checked);*/}
                {/*            onChange(field, val);*/}
                {/*        }}>自动提取</Checkbox>*/}
                {/*</div>*/}
                <style>
                    {
                        `
                        .rmt-textarea{
                         resize:none;
                        }
                        `
                    }
                </style>
            </div>
        )
    }

}